import { render } from "./formApperty.vue?vue&type=template&id=9c762be0&scoped=true"
import script from "./formApperty.vue?vue&type=script&lang=js"
export * from "./formApperty.vue?vue&type=script&lang=js"

import "./formApperty.vue?vue&type=style&index=0&id=9c762be0&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c762be0"]])

export default __exports__